import VendorCard from './VendorCard'
import { VENDORS, sortVendors } from '../vendors'

/**
 * The vendors as a single column, for the Vendor Partnerships panels (MYD-659).
 * The panel owns the scrolling, so this only stacks the cards.
 */
const VendorList = () => (
	<div className="space-y-3 p-3">
		{sortVendors(VENDORS).map(vendor => (
			<VendorCard key={vendor.id} vendor={vendor} />
		))}
	</div>
)

export default VendorList
